import API from './API.js'

export default class Events extends API {
  constructor() {
    super('events')
  }
}
